var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 23,
    height: 23,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2608 8.7404C10.2608 9.83804 11.1531 10.731 12.25 10.731C13.3469 10.731 14.2392 9.83804 14.2392 8.7404C14.2392 7.64277 13.3469 6.74977 12.25 6.74977C11.1531 6.74977 10.2608 7.64277 10.2608 8.7404ZM12.25 5.31195C14.1422 5.31195 15.676 6.84691 15.676 8.7404C15.676 10.6339 14.1422 12.1689 12.25 12.1689C10.3579 12.1689 8.82396 10.6339 8.82396 8.7404C8.82396 6.84691 10.3579 5.31195 12.25 5.31195ZM13.1868 1.94712C16.5279 2.40421 19.1021 5.27143 19.1021 8.7404C19.1021 10.1768 18.6607 11.5099 17.9063 12.6115L12.6625 20.8283C12.5663 20.9791 12.4081 21.0545 12.25 21.0545C12.0919 21.0545 11.9337 20.9791 11.8375 20.8283L6.59369 12.6115C5.83935 11.5099 5.39792 10.1767 5.39792 8.7404C5.39792 5.27143 7.97214 2.40421 11.3133 1.94712C11.4285 1.93135 11.5313 2.02082 11.5313 2.13716V2.44101C11.5313 2.95044 11.1962 3.3989 10.7079 3.54374C10.5165 3.60051 10.3279 3.66813 10.1426 3.74656C9.4979 4.01944 8.91863 4.41038 8.42081 4.90852C7.92303 5.40667 7.53238 5.98636 7.25969 6.63147C6.97769 7.29865 6.83473 8.0082 6.83473 8.7404C6.83473 9.8391 7.16123 10.8967 7.77894 11.7988L7.7921 11.818L7.80462 11.8376L12.25 18.8033L16.6954 11.8376L16.7079 11.818L16.7211 11.7988C17.3388 10.8967 17.6653 9.83911 17.6653 8.7404C17.6653 8.0082 17.5223 7.29865 17.2403 6.63147C16.9676 5.98636 16.577 5.40667 16.0792 4.90852C15.5814 4.41038 15.0021 4.01944 14.3574 3.74656C14.1721 3.66813 13.9836 3.60051 13.7921 3.54374C13.3038 3.3989 12.9688 2.95044 12.9688 2.44101V2.13716C12.9688 2.02082 13.0715 1.93135 13.1868 1.94712Z",
    fill: "#006564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.9dc072bd880b8bc8f57c66a14c03723e.svg";
export { ForwardRef as ReactComponent };